import { render, staticRenderFns } from "./q2.vue?vue&type=template&id=00542d6b&"
import script from "./q2.vue?vue&type=script&lang=js&"
export * from "./q2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports